export const AUTOTRANSLATOR_DIAGNOSTIC_RETENTION_MS = 7 * 24 * 60 * 60 * 1000;
export const AUTOTRANSLATOR_DIAGNOSTIC_CAPTURE_MS = 5 * 60 * 1000;
export const AUTOTRANSLATOR_DIAGNOSTIC_CHUNK_BYTES = 512 * 1024;
export const AUTOTRANSLATOR_DIAGNOSTIC_SESSION_BYTES = 8 * 1024 * 1024;
export const AUTOTRANSLATOR_DIAGNOSTIC_TOTAL_BYTES = 48 * 1024 * 1024;
export const AUTOTRANSLATOR_DIAGNOSTIC_MAX_SESSIONS = 10;
export const AUTOTRANSLATOR_DIAGNOSTIC_MAX_CHUNKS = 150;
export const AUTOTRANSLATOR_DIAGNOSTIC_PATH = "/api/autotranslator/diagnostic-audio";

export type AutotranslatorDiagnosticTrack = "raw" | "processed";
export type AutotranslatorDiagnosticEvent = { time: number; sequence: number; event: string; detail: string };
export type AutotranslatorDiagnosticSession = {
    id: string;
    debugSessionId: string;
    startedAt: number;
    receivedAt: number;
    expiresAt: number;
    stoppedAt: number | null;
    mode: string;
    mimeType: string;
    bytes: number;
    tracks: Record<AutotranslatorDiagnosticTrack, Array<{ index: number; bytes: number; offsetMs: number }>>;
    events: AutotranslatorDiagnosticEvent[];
    settings: Record<string, string | number | boolean | null>;
};

export const validAutotranslatorDiagnosticId = (id: unknown): id is string =>
    typeof id === "string" && /^[a-zA-Z0-9_-]{12,80}$/u.test(id);

export const isAutotranslatorDiagnosticMime = (mime: unknown): mime is string =>
    typeof mime === "string" && /^(audio\/(?:webm|mp4|ogg))(?:;\s*codecs=[a-zA-Z0-9.,_-]+)?$/u.test(mime);
